import { render, staticRenderFns } from "./agentChangePkgGroup.vue?vue&type=template&id=735cb98f&scoped=true&"
import script from "./agentChangePkgGroup.vue?vue&type=script&lang=js&"
export * from "./agentChangePkgGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735cb98f",
  null
  
)

export default component.exports